export enum HoneycombListsSpanNameEnum {
  CREATE_LIST_SUCCESS = 'create_list_success',
  DELETE_LIST_SUCCESS = 'delete_list_success',
  UPDATE_LIST_SUCCESS = 'update_list_success',
  GENERATE_LIST_SHARE_LINK_SUCCESS = 'generate_list_share_link_success',
  CREATE_LIST_ERROR = 'create_list_error',
  DELETE_LIST_ERROR = 'delete_list_error',
  UPDATE_LIST_ERROR = 'update_list_error',
  GENERATE_LIST_SHARE_LINK_ERROR = 'generate_list_share_link_error',
}
